import React, { Component } from 'react'
import Carousel from './carousel'
import classnames from 'classnames'
import Hammer from 'hammerjs'
import * as styles from './carousel.module.scss'
import './jquery.reflect'
import * as utils from './utils'
import ReactDOM from 'react-dom'
class CarouselComponent extends Component {
  startTime = 0

  constructor(props) {
    super(props);
    this.state = {
      width: 0
    };
  }

  componentDidMount() {
    this.startTime = Date.now()

    window.addEventListener("resize", this.resize, false);
  }

  resize = () => {
    this.carouselRef && this.initCarousel(this.carouselRef);
  }

  componentWillUnmount() {
    this.props.addEvent({
      event_category: 'products',
      event_action: 'view',
      event_label: 'index',
      event_value: {
        startAt: this.startTime,
        duration: (Date.now() - this.startTime) / 1000
      }
    })
  }

  clickItemHandler = (item, i) => event => {
    const url = item.link

    if (this.carousel.nearestIndex() === i) {
      this.props.history.push(url)
    }
  }

  initCarousel = (carouselRef) => {
    let _fixedVal = 0
    let screenResolutionCheck1 = (Math.round(screen.width / screen.height * 1000) / 1000) === 0.667
    let screenResolutionCheck2 = (Math.round(screen.height / screen.width * 1000) / 1000) === 1.5
    if(utils.isiPad() && screenResolutionCheck1 && screenResolutionCheck2) {
      _fixedVal = -20
    }
    this.carousel = new Carousel({
      el: $(carouselRef),
      yOrigin: 150,
      yRadius: window.screen.availWidth > 768 ? 100 + _fixedVal : 20,
      farScale: window.screen.availWidth > 768 ? 0.6 : 0.3,
      xRadius: window.screen.availWidth > 768 ? ($(carouselRef).width() / 2) : ($(carouselRef).width() / 1.0),
      mirror: {
        gap: 70,
        height: 0
      },
      buttonLeft: $("#nav > .left"),
      buttonRight: $("#nav > .right"),
      autoPlay: 0,
      bringToFront: true,
      onRendered: (carousel, y) => {
        const el = carousel.nearestItem().element;
        //减8是因为字体大小为17，为了居中(在phone里面header只有50px)
        let top = $(carouselRef).height() * 0.5 + y + carousel.options.mirror.gap - (window.screen.availWidth > 768 ? -80 : -65);
        $(this.refs.title).text(carousel.nearestItem().element.alt).css({ top: `${top}px` });
        $(el).css({
          filter: 'blur(0px)',
          // zoom: 1.2,
          opacity: 1
        }).siblings('div').css({
          filter: 'blur(3px)',
          // zoom: 1,
          opacity: 0.7
        });
      },
      onLoaded: carousel => {
        $(carouselRef).css({ visibility: 'visible' })
      }
    })

    this.gestureMove(carouselRef)
  }

  gestureMove = (carouselRef) => {
    const { items } = this.props
    const factor = 100;
    let that = this;
    if (items && items.length > 1 && !this.manager) {
      this.manager = new Hammer.Manager(ReactDOM.findDOMNode(carouselRef));
      let Swipe = new Hammer.Swipe();
      this.manager.add(Swipe);
      this.manager.on('swipe', function (e) {
        let count = Math.abs(e.deltaX) < factor ? (e.deltaX > 0 ? -1 : 1) : -parseInt(e.deltaX / factor);
        that.carousel && that.carousel.go(count);
      });
    }
  }

  renderItem = (item, i) => {
    const thumbnail = item.image
    const name = item.title

    let _isiPadPro129 = false
    let screenResolutionCheck1 = (Math.round(screen.width / screen.height * 1000) / 1000) === 0.667
    let screenResolutionCheck2 = (Math.round(screen.height / screen.width * 1000) / 1000) === 1.5
    if(utils.isiPad() && screenResolutionCheck1 && screenResolutionCheck2) {
      _isiPadPro129 = true
    }

    return (
      <div key={i} draggable={false} className={classnames('carousel_item', styles.item, _isiPadPro129 && styles.fixed_width)} onClick={this.clickItemHandler(item, i)}>
        <img src={thumbnail} alt={item.title} className={styles.thum} />
        <div className={styles.title} style={{ color: '#333' }}>{item.title}</div>
      </div>
    )
  }

  renderBody() {
    const { items } = this.props
    if (!items.length) {
      return (
        <div className={styles.notFound}>暂无文件</div>
      )
    }

    return (
      <div
        className={styles.carousel}
        ref={ref => {
          this.carouselRef = ref;
          ref && this.initCarousel(ref);

        }}>
        {items && items.map(this.renderItem)}
      </div>
    )
  }

  render() {
    return (
      <div className={classnames(styles.wrap, styles.main)}>
        {this.renderBody()}
        {/* <div className={styles.title} ref="title" /> */}
      </div>
    )
  }
}

export default CarouselComponent
